ImageValidator.$inject = ['validator'];

export default function ImageValidator(validator) {
    const instance = new validator();
    return instance;
}
